// extracted by mini-css-extract-plugin
module.exports = {"container":"StructureDiagramCanvas_container__29gpE"};